module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.0d248fe.woff";


//////////////////
// WEBPACK FOOTER
// ./autocomplete-component/src/fonts/Roboto-Regular.woff
// module id = xJDW
// module chunks = 1